/**
 * woMaterials.js: one reader for a work-order material row (IDI-187).
 *
 * The "0 of 0": the materials list read `mat.total`, which no writer sets.
 * woMaterialsProjection writes `quantity` / `coverage` (and `actualUsed` /
 * `used`), so every seeded row read 0 quoted. These readers take whichever
 * spelling the row carries. Rounded for display (sq ft arrive as 170.67).
 */

const num = (v) => {
  const n = typeof v === 'string' ? Number(v.trim()) : v;
  return typeof n === 'number' && Number.isFinite(n) ? n : null;
};
const first = (row, keys) => {
  for (const k of keys) {
    const n = num(row?.[k]);
    if (n != null) return n;
  }
  return null;
};

/** Quoted amount (null when the row records none). */
export function materialQuoted(row) {
  return first(row, ['total', 'quantity', 'coverage', 'quotedQty', 'qty']);
}

/** Used so far (0 when nothing recorded). */
export function materialUsed(row) {
  return first(row, ['used', 'actualUsed', 'usedQty']) ?? 0;
}

/** Display: whole numbers as-is, otherwise up to 2 decimals. */
export function fmtQty(n) {
  if (n == null) return '\u2014';
  return Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100);
}

/**
 * IDI-490 (explicit state): a MIGRATED work order (legacy id, no materials)
 * says the legacy system didn't record them, rather than "No materials
 * tracked", which reads like a fault.
 */
export function noMaterialsMessage(wo) {
  const migrated = !!(wo?.legacyId || (wo?.id && /^\d+$/.test(String(wo.id))));
  return migrated ? 'Materials were not recorded in the legacy system for this work order' : 'No materials tracked';
}
